import {
  MODAL_TOUCHPOINT_HEADLINE_INFO_TOGGLE,
} from './actions';

const initialState = {
  isOpenModalTouchpointHeadline: false,
  modalTouchpointHeadlineContent: null,
};

export const reducer = (state = initialState, action) => {
  if (action.type === MODAL_TOUCHPOINT_HEADLINE_INFO_TOGGLE) {
    return {
      ...state,
      isOpenModalTouchpointHeadline: action.payload.isOpen,
      modalTouchpointHeadlineContent: action.payload.modalContent,
    };
  }
  return state;
};
